import { TYPE_FORMAT } from "./numericTypes";

export const safeNumber = (v) => {
    if (v === "" || v === null || v === undefined) return null;
    const n = Number(v);
    return Number.isFinite(n) ? n : null;
};

export const parseNumeric = (str) => {
    if (!str || str.trim() === "") return null;
    // 콤마 제거하고 숫자만 추출
    const cleaned = str.replace(/[,\s]/g, "");
    const num = parseFloat(cleaned);
    return isNaN(num) ? null : num;
};

export const formatByType = (value, type) => {
    const num = safeNumber(value);
    if (num === null) return "";

    const opt = TYPE_FORMAT[type] || TYPE_FORMAT.price;

    try {
        return num.toLocaleString(undefined, {
            minimumFractionDigits: opt.min,
            maximumFractionDigits: opt.max
        });
    } catch {
        return "";
    }
};

export function validateNumber(value) {
    if (value === "" || value === null || value === undefined) {
        return "필수 입력 항목입니다";
    }

    const num = Number(value);
    if (isNaN(num)) {
        return "올바른 숫자를 입력해주세요";
    }

    if (!isFinite(num)) {
        return "숫자가 너무 큽니다";
    }

    if (num < 0) {
        return "양수를 입력해주세요";
    }

    return null;
}

export const formatResultValue = (value, { isPrice = false, isPriceInt = false, isPriceFloat = false, isPercentage = false, isAmount = false, isDouble = false, currency = "€" } = {}) => {
    const num = safeNumber(value);
    if (num === null || num === undefined || isNaN(num)) return "-";

    if (isPercentage) {
        return `${num.toLocaleString(undefined, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        })} %`;
    }

    // if (isPrice) {
    //     // ₩는 정수로, €는 소수점 둘째자리로 표시
    //     const decimals = currency === "₩" ? 0 : 2;
    //     return `${currency} ${num.toLocaleString(undefined, {
    //         minimumFractionDigits: decimals,
    //         maximumFractionDigits: decimals
    //     })}`;
    // }
    if (isPrice) {
        return `${currency} ${num.toLocaleString(undefined, {
            minimumFractionDigits: 0,
            maximumFractionDigits: 2
        })}`;
    }

    if (isPriceInt) {
        return `${currency} ${num.toLocaleString(undefined, {
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
        })}`;
    }

    if (isPriceFloat) {
        return `${currency} ${num.toLocaleString(undefined, {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        })}`;
    }

    if (isAmount) {
        return `${num.toLocaleString(undefined, {
            minimumFractionDigits: 0,
            maximumFractionDigits: 0
        })}`;
    }

    if (isDouble) {
        return `${num.toLocaleString(undefined, {
            minimumFractionDigits: 4,
            maximumFractionDigits: 4
        })}`;
    }

    return num.toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    });
};
